/**
 * [倒计时插件，只支持到“天”倒计时]
 * author: Jerman
 * date: 2016.10.12
 * description: 具体参数请查看defaults默认值
 * 最新插件
 */
import { assignIn } from 'lodash';

export default function(_this, options, callback) {
  // 默认参数
  const defaults = {
    ele: null,
    // 倒计时数值，单位"秒"，整数值，默认60秒,注：只能传入整数值
    time: 60,
    // 倒计时间隔 ，默认为1秒
    interval: 1000,
    // 默认输出格式,默认date：时间倒计时。number:纯数字倒计时,如60秒、120秒用到
    format: 'date',
    // 天、时、分、秒小于10时，补0，默认为false,不补0
    zero: false,
    // 是否显示0天、0时、0分,默认为true,显示
    zeroShow: true,
    // 倒计时，时间对象
    timer: null,
    // 每一秒输出的回调,注：有render时，表示自定义输出格式，默认输出格式不再生效
    render: null,
    // 结束后的回调,即0秒时的回调
    end: null,
    // 每秒倒计时调用
    callback: null,
    // 输出的日期
    date: {
      day: 0,
      hour: 0,
      minute: 0,
      second: 0,
    },
    // 默认时间单位
    // 默认输出格式 "XX天 XX时XX分XX秒"
    dateText: {
      day: ' Day ',
      hour: ' Hour ',
      minute: ' Minute ',
      second: ' Second ',
    },
  };
  const opts = assignIn(defaults, options);

  opts.ele = _this;

  // 如果当前元素已经有个倒计时,则清除
  if (opts.timer) {
    clearInterval(opts.timer);
  }

  // 格式
  const format = opts.format;

  // 初始化结束函数
  if (!opts.end) {
    opts.end = function() {
      clearInterval(opts.timer);
    };
  }

  let action = null;
  // 纯数字倒计时
  if (format === 'number') {
    // 初始化second
    opts.date.second = opts.zero && opts.time < 10 ? `0${opts.time}` : opts.time;

    action = function(_time) {
      if (typeof opts.render === 'function') {
        opts.render(opts);
      } else {
        _this.innerHTML = _time;
      }
    };
    // 初始化
    action(opts.time);
    // 倒计时
    opts.timer = setInterval(() => {
      if (opts.time > 1) {
        opts.time--;
        // 记录秒数
        opts.date.second = opts.zero && opts.time < 10 ? `0${opts.time}` : opts.time;
        action(opts.time);
      } else {
        clearInterval(opts.timer);
        opts.end(opts);
      }
    }, opts.interval);
  } else {
    // 计算天时分的秒数
    const daysSecond = 24 * 60 * 60; // 86400s
    const hoursSecond = daysSecond / 24; // 3600s
    const minutesSecond = hoursSecond / 60; // 60s

    action = function(_time) {
      // 天
      const mydays = parseInt(_time / daysSecond);
      opts.date.day = mydays >= 0 ? (opts.zero && mydays < 10 ? `0${mydays}` : mydays) : '';
      // 时
      const myhours = parseInt((_time - mydays * daysSecond) / hoursSecond);
      opts.date.hour = myhours >= 0 ? (opts.zero && myhours < 10 ? `0${myhours}` : myhours) : '';
      // 分
      const myminutes = parseInt(
        (_time - mydays * daysSecond - myhours * hoursSecond) / minutesSecond
      );
      opts.date.minute =
        myminutes >= 0 ? (opts.zero && myminutes < 10 ? `0${myminutes}` : myminutes) : '';
      // 秒
      const myseconds =
        _time - mydays * daysSecond - myhours * hoursSecond - myminutes * minutesSecond;
      opts.date.second =
        myseconds >= 0 ? (opts.zero && myseconds < 10 ? `0${myseconds}` : myseconds) : '';

      if (typeof opts.render === 'function') {
        opts.render(opts);
      } else {
        let dateStr = '';
        const dayStr = opts.date.day + opts.dateText.day;
        const hourStr = opts.date.hour + opts.dateText.hour;
        const minuteStr = opts.date.minute + opts.dateText.minute;
        const secondStr = opts.date.second + opts.dateText.second;

        if (opts.zeroShow) {
          // 显示00天、00时、00分
          dateStr = dayStr + hourStr + minuteStr + secondStr;
        } else {
          // 隐藏00天、00时、00分
          if (opts.date.day > 0) {
            dateStr = dayStr + hourStr + minuteStr + secondStr;
          } else {
            if (opts.date.hour > 0) {
              dateStr = hourStr + minuteStr + secondStr;
            } else {
              if (opts.date.minute > 0) {
                dateStr = minuteStr + secondStr;
              } else {
                dateStr = secondStr;
              }
            }
          }
        }
        _this.innerHTML = dateStr;
      }
    };
    // 初始化
    action(opts.time);

    // 倒计时
    opts.timer = setInterval(() => {
      // 如果使用opts.time>0，倒计时会多1秒
      if (opts.time > 1) {
        opts.time--;
        action(opts.time);
      } else {
        clearInterval(opts.timer);
        opts.end(opts);
      }
      opts.callback && opts.callback(opts);
    }, opts.interval);
  }

  // 总的回调
  if (typeof callback === 'function') {
    callback(_this, opts);
  }

  return opts.timer;
}
